import React, { useState, useEffect } from "react";
import Header from "../layout/header";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import WOW from "wowjs";
import Metatag from "../../hooks/Metatag";
import global from "../../global-variables";
import { useNavigate} from "react-router-dom";
import { GetCareerList } from "../../api/career-functions";
import {
  FaEllipsisH,
  FaRegImage,
  FaLink,
  FaVideo,
  FaRegFilePdf,
} from "react-icons/fa";
import $ from "jquery";

export default function JoinUs() {
  
  const navigate = useNavigate();
  const [careerList, setCareerList] = useState(null);

  // success function when the list is retrived
  const OnGetCareerSuccess = (p_response) => {
    // set the list for looping
    setCareerList(p_response);
  }

  // things to be done when the page is loaded
  useEffect(() => {
    //make the object for getting the active career list
    let _objCareerList = new Object();
    _objCareerList.career_status = 1;
    // call the function to get the career
    GetCareerList(_objCareerList, OnGetCareerSuccess,navigate);

  }, []);

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [careerList]);

  return (
    <>
      <Header main_className="bg-header"></Header>

      {/* Metatag  */}
      <Metatag
        title="Jobs at National Disease Modelling Consortium | Work with NDMC IIT-B"
        keywords="Jobs at National Disease Modelling Consortium, Work with NDMC IIT-B, Disease Research Analyst Job Opening, Disease Research Associate Job at NDMC IIT-B"
        description="Current Job Openings and Job Vacancies at The National Disease Modelling Consortium at Indian Institute of Technology Bombay."
      />

      <Container
        fluid
        className="px-0 bg-visual position-relative"
        style={{
          backgroundImage: "url('./images/bg-career.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <img
          src={global.variables.strDomainUrl + "images/bg-blank.png"}
          alt=""
          title=""
          className="w-100"
        />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5">
            <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">
              JOIN US
            </h1>
          </Container>
        </div>
      </Container>

      <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
        {
          careerList != null ?
            careerList.length > 0 ?
              careerList.map((val,index)=>{
                return(
                  <Row key={index} className="grid-item wow fadeInUp">
                    <div className="col-xl-10 col-lg-9">
                      <h4 class="fw-bold red-text">
                      Position: {val.career_name}
                      </h4>
                      <h5 className="fw-bold">Job Profile:</h5>
                      {
                        val.career_desc != null && val.career_desc != "" ?
                        <span dangerouslySetInnerHTML={{__html : val.career_desc}}></span>
                        : 
                        null
                      }
                    </div>
                    <div className="col-xl-2 col-lg-3">
                      <div className="d-flex flex-lg-column gap-3 justify-content-between">
                        {
                          val.career_pdf != null && val.career_pdf != "" ?
                          <a
                            href={global.variables.strApiUrl + "/career-documents/" +   val.career_pdf}
                            target="_blank"
                            className="btn btn-slide rounded-pill py-2 px-4"
                          >
                            <FaRegFilePdf className="pe-1"/> 
                            Read More
                          </a>
                          :
                          null
                        }
                        {
                          val.career_apply_url != null && val.career_apply_url != "" ?
                        <a
                          href={val.career_apply_url}
                          target="_blank"
                          className="btn btn-slide rounded-pill py-2 px-4"
                        >
                          <FaLink className="pe-1"/> 
                          Apply Now
                        </a>
                        :
                        null
                        }
                      </div>
                    </div>
                  </Row>

                )
              })
            :
              <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                <Row>
                  <span className="text-center"><b>No records found</b></span>
                </Row>
              </Container>
          :
          // <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
            <Row>
              <span className="text-center">Loading...</span>
            </Row>
          // </Container>
        }
      </Container>

      {/* Breadcrumb */}
      <Container
        Container
        fluid
        className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto"
      >
        <Breadcrumb>
          <Breadcrumb.Item href={global.variables.strDomainUrl}>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Join Us</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}
